// eslint-disable-next-line no-restricted-imports
import {
  CreateLegalClientBeneficiaryByAdminDto_Input,
  MutationInput_LegalClientBeneficiaryController_Create_Input_PepConnectionType as PepConnectionTypeApi,
} from 'api/generated/graphql';
import { RelationType } from 'api/types/entity';
import { CreateLegalClientBeneficiaryParams } from 'api/types/params';
import { formatToISODate } from 'helpers';

import { parsePriceParam } from '../parseParam';

const relationType: Record<RelationType, PepConnectionTypeApi> = {
  [RelationType.not]: PepConnectionTypeApi.None,
  [RelationType.yesSpouses]: PepConnectionTypeApi.FamilyMember,
  [RelationType.yesIAm]: PepConnectionTypeApi.Self,
};

export const parseCreateLegalClientBeneficiaryParams = (
  params: CreateLegalClientBeneficiaryParams
): CreateLegalClientBeneficiaryByAdminDto_Input => ({
  email: params.email,
  legalClientId: params.legalClientId,
  versionNumber: params.versionNumber,
  firstName: params.firstName,
  lastName: params.lastName,
  reason: params.reason,
  middleName: params.middleName,
  dateOfBirth: formatToISODate(params.dateOfBirth),
  citizenships: params.citizenships,

  registrationAddress: params.registrationAddress,
  residentialAddress: params.residentialAddress,
  taxResidences: params.taxResidences,

  connectedPepInfo: params.connectedPepInfo,

  pepConnectionType: relationType[params.pepConnection],

  placeOfBirth: params.placeOfBirth,
  directCapitalParticipationPercentage:
    params.directCapitalParticipationPercentage,

  financialConditionAmount: params.financialConditionAmount
    ? parsePriceParam(params.financialConditionAmount)
    : undefined,

  hasControlOverLegalClient: params.hasControlOverLegalClient,
  indirectCapitalParticipationPercentage:
    params.indirectCapitalParticipationPercentage,

  controlOverLegalClientStatus: params.controlOverLegalClientStatus,
});
